import React, { useCallback } from 'react';

import ReactEcharts from 'echarts-for-react';
import { RoundChartOption } from '../ChartOption/RoundChartOption';
import { SeriePointT } from '../../types';
import { useSetPieLegendDimension } from '../hooks/legendDimension';

type BaseRoundChartProps = {
    orderedColumns: {
        y: ResponseColumnT;
        x: ResponseColumnT;
        z?: ResponseColumnT;
    };
    className: string;
    onClick: FlowAnyFunction;
    width: number;
    height: number;
    optionBuilder: RoundChartOption;
};

const BaseRoundChart = ({
    height,
    width,
    orderedColumns,
    className,
    onClick = () => {},
    optionBuilder,
}: BaseRoundChartProps): React.ReactElement => {
    const xColumn = orderedColumns.x;
    const onChartClick = useCallback(
        ({ value }: SeriePointT & { rawXData: ResponseDataValueT }) => {
            onClick({ [xColumn.key]: value.rawXData }, xColumn.key);
        },
        [xColumn.key],
    );

    const dimensions = optionBuilder.getDimensions();
    useSetPieLegendDimension(xColumn, dimensions as string[]);

    const option = optionBuilder.getChartOption();

    return (
        <ReactEcharts
            option={option}
            onEvents={{ click: onChartClick }}
            style={{ height, width }}
            className={className}
            opts={{ renderer: 'canvas' }}
        />
    );
};

export default BaseRoundChart;
